import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Header from "./components/Header";
import Home from "./pages/Home";
import Project from "./components/ProjectDetails";
import Designs from "./pages/Designs";
import Projects from "./pages/Projects";
import About from "./pages/About";
import Footer from "./components/Footer";
import Scroll from "./Scroll";

export default function Main() {
  return (
    <Router>
      <Scroll />
      <Header />

      <main className="app-page">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/project" element={<Projects />} />
          <Route path="/project/:slug" element={<Project />} />
          <Route path="/design-gallery" element={<Designs />} />
          <Route path="/about" element={<About />} />
        </Routes>
        <Footer />
      </main>
    </Router>
  );
}
